export default __webpack_public_path__ + "static/media/progressBars.2b286115.svg";